import type { PlaceholderTextPluginOptions } from '@atlaskit/editor-plugin-placeholder-text';

interface Props {
	options: never;
}

export function placeholderTextPluginOptions({}: Props): PlaceholderTextPluginOptions {
	return {};
}
